if (!window.Turbo) {
	require("@hotwired/turbo");
}

import './_fetch.js'
import './_prefetch.js'
import './_submit.js'
import './_render.js'

document.addEventListener("turbo:before-fetch-response", (event) => {
	if (
		event.detail.fetchResponse?.response?.status === 404
		&& event.target?.tagName?.toLowerCase() === 'html'
	) {
		location.href = event.detail.fetchResponse?.response?.url;
		return false;
	}
});

document.addEventListener("turbo:render", (event) => {
	[...event.target?.querySelectorAll('.vg-sidebar')].forEach((el) => el.classList.remove('open'));
	event.target?.querySelector('body')?.classList.remove('vg-sidebar-open', 'header--is-scroll', 'header--is-fixed');
	event.target?.querySelector('.vg-nav-hamburger')?.classList.remove('vg-sidebar-active');

	event.target?.querySelector('[data-vg-toggle="categories"]')?.classList.remove('active');
	event.target?.querySelector('header .header-wrapper')?.classList.remove('hide', 'scroll', 'fixed');
	//event.target?.querySelector('.toast.show')?.classList.remove('show');
});
